import React, { useState, useEffect, useRef } from "react";
import "./domain.css";

import Retail from "../../assets/images/retail-domain.png";
import { useLocation } from "react-router-dom";

import ReactCardFlip from "react-card-flip";

import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

const RetailDomain = () => {
  const [play, setPlay] = useState(false);

  const vidRef = useRef(null);

  const [isFlipped1, setIsFlipped1] = useState(false);
  const [isFlipped2, setIsFlipped2] = useState(false);
  const [isFlipped3, setIsFlipped3] = useState(false);
  const [isFlipped4, setIsFlipped4] = useState(false);

  const handleMouseEnter = (num) => {
    console.log(num);
    if (num === "1") {
      setIsFlipped1(true);
    } else if (num === "2") {
      setIsFlipped2(true);
    } else if (num === "3") {
      setIsFlipped3(true);
    } else if (num === "4") {
      setIsFlipped4(true);
    }
  };

  const handleMouseLeave = (num) => {
    console.log(num);
    if (num === "1") {
      setIsFlipped1(false);
    } else if (num === "2") {
      setIsFlipped2(false);
    } else if (num === "3") {
      setIsFlipped3(false);
    } else if (num === "4") {
      setIsFlipped4(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
     AOS.init();
  }, []);

  const handlePlay = () => {
    if (vidRef && vidRef.current) {
      if (vidRef.current.paused) {
        setPlay(true);
        vidRef.current.play();
      } else {
        setPlay(false);
        vidRef.current.pause();
      }
    }
  };

  return (
    <>
      <div className="domain-banner retail">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="content">
            <div className="heading" data-aos="fade-up" data-aos-duration="1500">
              <div className="heading-flex">
                <h2>Retail</h2>
                <h4>
                  Elevate Your Retail Workforce with Customized Digital Training
                </h4>
                <p>
                  In the fast-paced world of retail, where tradition meets
                  innovation and customer delight is key, the idea of diving
                  into modern training methods like e-training might seem
                  overwhelming. But, could this be the game-changer your team
                  needs to stay ahead? After all, e-training isn't just a
                  passing trend—it's a powerful tool that could revolutionize
                  how your retail workforce is prepared for success. Ready to
                  take the leap? Let’s get started.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-banner-circle"></div>
        <div className="domain-section-content">
          <div className={play ? "domain-main-img play" : "domain-main-img"}>
            <img src={Retail} alt="" />
            <div className="domain-opq-dummy">
              <div class="step" onClick={handlePlay}>
                {play ? (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Bold"
                      viewBox="0 0 24 24"
                      width="40"
                      height="40"
                      fill="#37466F"
                    >
                      <path d="M9,17V7a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1Z"></path>
                      <path d="M14,17V7a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1h-2a1,1,0,0,1-1-1Z"></path>
                    </svg>
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Bold"
                      viewBox="0 0 24 24"
                      width="70"
                      height="40"
                      fill="#37466F"
                    >
                      <path d="M9,17.879V6.707A1,1,0,0,1,10.707,6l5.586,5.586a1,1,0,0,1,0,1.414l-5.586,5.586A1,1,0,0,1,9,17.879Z"></path>
                    </svg>
                  </>
                )}

                <div class="ripple"></div>
                <div class="ripple"></div>
                <div class="ripple"></div>
              </div>
            </div>
            <div className="domain-player">
              <video ref={vidRef} controls controlsList="nodownload" muted>
                <source src="https://fidusindia.in/assets2/domains/videos/RetailDomain.mp4" />
              </video>
            </div>
          </div>
          <div className="domain-main">
            <div className="domain-main-content" data-aos="fade-up" data-aos-duration="1500">
              <h2>Challenges Addressed by eTraining in Retail Industry</h2>
              <div className="retail-desc-cont">
                <div
                  onMouseEnter={() => handleMouseEnter("1")}
                  onMouseLeave={() => handleMouseLeave("1")}
                >
                  <ReactCardFlip
                    isFlipped={isFlipped1}
                    flipDirection="horizontal"
                  >
                    <div className="front-component f1-img">
                      <div className="front-opaque"></div>
                      <p>High Employee Turnover</p>
                    </div>

                    <div className="back-component">
                      <p>
                        The retail industry often faces high turnover rates due
                        to factors such as seasonal demand, temporary
                        employment, and career mobility.
                      </p>
                    </div>
                  </ReactCardFlip>
                </div>
                <div
                  onMouseEnter={() => handleMouseEnter("2")}
                  onMouseLeave={() => handleMouseLeave("2")}
                >
                  <ReactCardFlip
                    isFlipped={isFlipped2}
                    flipDirection="horizontal"
                    
                  >
                    <div className="front-component f2-img">
                      <div className="front-opaque"></div>
                      <p>Product Knowledge and Sales Skills</p>
                    </div>

                    <div className="back-component">
                      <p>
                        In afast-paced retail environment, employees need to
                        possess comprehensive product knowledge and effective
                        sales techniques to meet customer needs and drive sales.
                      </p>
                    </div>
                  </ReactCardFlip>
                </div>
                <div
                  onMouseEnter={() => handleMouseEnter("3")}
                  onMouseLeave={() => handleMouseLeave("3")}
                >
                  <ReactCardFlip
                    isFlipped={isFlipped3}
                    flipDirection="horizontal"
                  >
                    <div className="front-component f3-img">
                      <div className="front-opaque"></div>
                      <p>Customer Experience and Service Quality</p>
                    </div>

                    <div className="back-component">
                      <p>
                        Providing exceptional customer service is paramount in
                        the retail industry to build brand loyalty and drive
                        repeat business.
                      </p>
                    </div>
                  </ReactCardFlip>
                </div>
                <div
                  onMouseEnter={() => handleMouseEnter("4")}
                  onMouseLeave={() => handleMouseLeave("4")}
                >
                  <ReactCardFlip
                    isFlipped={isFlipped4}
                    flipDirection="horizontal"
                  >
                    <div className="front-component f4-img">
                      <div className="front-opaque"></div>
                      <p>Performance Tracking and Analytics</p>
                    </div>

                    <div className="back-component">
                      <p>
                        Monitoring employee performance and assessing the
                        effectiveness of training initiatives are critical for
                        identifying areas of improvement and optimizing resource
                        allocation.
                      </p>
                    </div>
                  </ReactCardFlip>
                </div>
              </div>
            </div>
          </div>
          <div className="domain-main reverse">
            <div className="domain-main-content" data-aos="fade-up" data-aos-duration="1500">
              <h2>Investing in eTraining for Retail Training</h2>
              <p>
                By investing in eTraining, retail organizations can empower
                their staff to:
              </p>
              <div className="retail-desc-cont2">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="retail-circle">
                        <div className="retail-circle-img">
                          <img
                            src="https://fidusindia.in/assets2/domains/images/retailDesc1.png"
                            alt="retail1"
                            className="img-fluid"
                          />
                        </div>
                        <p>Exceptional Customer Service</p>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="retail-circle">
                        <div className="retail-circle-img">
                          <img
                            src="https://fidusindia.in/assets2/domains/images/retailDesc2.png"
                            alt="retail1"
                            className="img-fluid"
                          />
                        </div>
                        <p>Increased Retail Sales</p>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="retail-circle">
                        <div className="retail-circle-img">
                          <img
                            src="https://fidusindia.in/assets2/domains/images/retailDesc3.png"
                            alt="retail1"
                            className="img-fluid"
                          />
                        </div>
                        <p>Digital Transformation</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="domain-main">
            <div className="domain-main-content" data-aos="fade-up" data-aos-duration="1500">
              <h4>
                Contact us today to discuss your training needs and discover how
                our eTraining expertise can drive success for your retail
                business.
              </h4>
              <Link className="read-more-product" to={"/request"}>
                <span>Contact Us !</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RetailDomain;
